import React from 'react';
import { CHECKOUT_URL } from '../data/content';
import { trackCheckoutIntent } from '../utils/analytics';
type CTAButtonProps = {
  children: React.ReactNode;
  location: string;
  variant?: 'solid' | 'outline';
  className?: string;
};
export function CTAButton({
  children,
  location,
  variant = 'solid',
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-full px-9 py-4 font-sans text-[0.7rem] uppercase tracking-luxe transition-all duration-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ivory';
  const styles = variant === 'solid' ? 'bg-ink text-ivory shadow-[0_10px_30px_-16px_rgba(58,51,46,0.6)] hover:bg-gold hover:shadow-[0_16px_36px_-14px_rgba(183,148,87,0.65)] hover:-translate-y-0.5' : 'border border-nude text-ink hover:border-gold hover:text-gold';
  return <a href={CHECKOUT_URL} onClick={() => trackCheckoutIntent(location)} className={`${base} ${styles} ${className}`} data-id="element-43" data-mp="38pabhs64cczj">
      <span data-id="element-44" data-mp="19ahc2q4peky8">{children}</span>
      <span aria-hidden="true" className="h-[1px] w-5 bg-current transition-all duration-500 group-hover:w-8" data-id="element-45" data-mp="19b98u4a1eoq3" />
    </a>;
}